import React, { useState } from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import DeleteButton from 'client/app/apps/protocols/EditProtocol/DefineProtocol/StepCard/DeleteButton';

type Props<TItem> = {
  items: TItem[];
  getItemKey: (item: TItem, index: number) => string;
  renderItemContents: (item: TItem, index: number) => React.ReactNode;
  onDelete?: (index: number) => void;
};

export function StepContents<TItem>({
  items,
  getItemKey,
  renderItemContents,
  onDelete,
}: Props<TItem>) {
  const [activeItemIndex, setActiveItemIndex] = useState<number | undefined>();
  return (
    <StyledContentsWrapper variant="outlined">
      <List>
        {items.map((item, index) => {
          const contents = renderItemContents(item, index);
          if (!contents) {
            return null;
          }
          return (
            <ListItem
              key={`step-contents-${getItemKey(item, index)}`}
              onMouseEnter={() => setActiveItemIndex(index)}
              onMouseLeave={() => setActiveItemIndex(undefined)}
              secondaryAction={
                activeItemIndex === index &&
                onDelete && <DeleteButton onClick={() => onDelete(index)} />
              }
            >
              {contents}
            </ListItem>
          );
        })}
      </List>
    </StyledContentsWrapper>
  );
}

const StyledContentsWrapper = styled(Paper)({
  borderRadius: '4px',
  width: '100%',
});
